export enum EColorButton {
  Blue = 'blue',
  Green = 'green',
  red = 'red',
  Yellow = 'yellow',
  Gray = 'gray',
  BlueTrace = 'blue-trace',
  BlueTrace2 = 'blue-trace-2',
  CyanTrace = 'cyan-trace',
  GreenTrace = 'green-trace',
  RedTrace = 'red-trace',
  YellowTrace = 'yellow-trace'
}
